export default __webpack_public_path__ + "static/media/zoneofgluttony.e4ebe944.png";